import React, { useContext, useEffect, useState } from "react";
import Navbar from "../../../common/layout/Navbar";
import { LicenseTypes, Operation, empType } from "../../../../utils/Enum.types";
import { Title } from "../../../../stories/Title/Title";
import { Tab, Tabs, TextField } from "@mui/material";
import { Button } from "../../../../stories/Button/Button";
import { useNavigate } from "react-router-dom";
import { a11yProps, TabPanel } from "../../../../styles/Tabs";
import MeetingDetails from "./view/MeetingDetails";
import History from "./view/History";
import {
  GetMomNameByNodeId,
  GetProjectNameInNodeId,
} from "../masters/projects/queries/queries";
import { nodeVar } from "../../../../utils/commonQueryTypes";
import {
  AtsMomMaster,
  UpdateViewedStatusResult,
  UpdateViewedStatusVar,
} from "./queries/types";
import { useLazyQuery, useMutation } from "@apollo/client";
import useUrlParams from "../../../../customHooks/useUrlParams";
import {
  toInputStandardDate,
  toStandardDate,
} from "../../../../utils/UtilFunctions";
import { AtsAcLdgrProjects } from "../masters/projects/queries/types";
import { AppContext } from "../../../../context/context";
import { UpdateViewedStatus } from "./queries/mutations";
import { msgType } from "../../../../utils/types";
import { emptyMessage } from "../../../../utils/constants";
import useLoggedInUserDetails from "../../../../customHooks/useLoggedInUserDetails";
import { GetProjectsForMom } from "../masters/subsidary/junctions/queries/queries";
import MessageModal from "../../../../customComponents/MessageModal";
import { KeyboardDoubleArrowLeft } from "@mui/icons-material";

interface Props {
  discussed: boolean;
}

const ViewMeetingDetails = ({ discussed }: Props) => {
  const navigate = useNavigate();
  const [value, setValue] = useState(0);
  const [previousDetails, setPreviousDetails] = useState(false);
  const { customer_id, momID, projectID } = useUrlParams();
  const { state } = useContext(AppContext);
  const [message, setMessage] = useState<msgType>(emptyMessage);
  const { user_details } = useLoggedInUserDetails();

  const [GetMomDate, { data: momDateDetail }] = useLazyQuery<
    { node: AtsMomMaster },
    nodeVar
  >(GetMomNameByNodeId);

  const [GetProject, { data: projectNameData }] = useLazyQuery<
    { node: AtsAcLdgrProjects },
    nodeVar
  >(GetProjectNameInNodeId);

  const [updateViewedStatus, { loading: updateViewedStatusLoading }] =
    useMutation<UpdateViewedStatusResult, UpdateViewedStatusVar>(
      UpdateViewedStatus,
      {
        onError: (e) => {
          setMessage({
            flag: true,
            message: e.message,
            operation: Operation.NONE,
          });
        },
      }
    );

  useEffect(() => {
    if (momID) {
      GetMomDate({
        variables: {
          id: momID,
        },
      });
    }
  }, [momID, GetMomDate]);

  useEffect(() => {
    if (projectID) {
      GetProject({
        variables: {
          id: projectID,
        },
      });
    }
  }, [projectID, GetProject]);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const UpdateView = (viewed: boolean) => {
    if (customer_id && momID && projectID) {
      updateViewedStatus({
        variables: {
          user_details,
          customerID: customer_id,
          momID,
          projectID,
          viewed,
        },
        refetchQueries: [
          {
            query: GetProjectsForMom,
            variables: {
              customerID: customer_id,
              empID: user_details.id,
              momID,
              latest: true,
            },
          },
        ],
      }).then(({ data }) => {
        if (data && data.UpdateViewedStatus) {
          setMessage({
            flag: true,
            message: "Updated successfully",
            operation: Operation.UPDATE,
          });
          navigate(`/${customer_id}/minutesofmeeting/${momID}`);
        }
      });
    }
  };

  return (
    <>
      <Navbar NavType={LicenseTypes.DASHBOARD} />
      <Title>Project Minutes of Meeting</Title>
      <div className="view-meeting-details">
        <div className="view-meeting-details__flex row g-0">
          <div className="col view-meeting-details__subtitle">
            {projectNameData ? (
              <>
                <b>{projectNameData.node.name}</b>
                <span>({projectNameData.node.supplierName.desc})</span>
                <b className="font-green">
                  {toStandardDate(projectNameData.node.startDate)} -
                </b>
                <b className="font-red">
                  {toStandardDate(projectNameData.node.endDate)}
                </b>
              </>
            ) : null}
          </div>
          <div className="col-3 flex-end">
            <TextField
              label="Date"
              className="project-meetings__textfield"
              slotProps={{
                inputLabel: { shrink: true },
              }}
              type="date"
              disabled
              value={
                momDateDetail
                  ? toInputStandardDate(momDateDetail.node.meetingDate)
                  : null
              }
            />
          </div>
        </div>
        <div className="view-meeting-details__block">
          <div className="view-meeting-details__block--tabs row g-0">
            <div className="col">
              <Tabs value={value} onChange={handleChange}>
                <Tab label="Minutes of Meeting" value={0} {...a11yProps(0)} />
                <Tab label="History" value={1} {...a11yProps(1)} />
              </Tabs>
            </div>
            {value !== 1 && (
              <div className="col-2 flex-end">
                <button
                  className="view-meeting-details__block--previous"
                  onClick={() => setPreviousDetails(!previousDetails)}
                >
                  <KeyboardDoubleArrowLeft /> Show Previous Meeting
                </button>
              </div>
            )}
          </div>
          <div className="view-meeting-details__block--tabpanel row g-0">
            <TabPanel value={value} index={0}>
              <MeetingDetails previous_details={previousDetails} />
            </TabPanel>
            <TabPanel value={value} index={1}>
              <History />
            </TabPanel>
          </div>
        </div>
        <div className="row g-0 view-meeting-details__buttons">
          <div className="col">
            <Button
              mode="back"
              onClick={() => {
                if (value) {
                  setValue(0);
                } else navigate(-1);
              }}
            />
          </div>
          <div className="col flex-end">
            {state.empSubType === empType.PMU ? (
              discussed ? (
                <Button
                  onClick={() => UpdateView(false)}
                  mode="mark-as-not-discussed"
                />
              ) : (
                <Button
                  onClick={() => UpdateView(true)}
                  mode="mark-as-discussed"
                />
              )
            ) : null}
          </div>
        </div>
      </div>
      <MessageModal
        handleClose={() => setMessage(emptyMessage)}
        modalFlag={message.flag}
        operation={message.operation}
        value={message.message}
      />
    </>
  );
};

export default ViewMeetingDetails;
